




























import Vue from "vue";
import Component from "vue-class-component";
import { getModule } from "vuex-module-decorators";
import AppModule from "@/store/modules/app.module";


@Component({ name: "DevLinks" })
export default class DevLinks extends Vue {
  public appModule = getModule(AppModule, this.$store);

  showCode(item: any) {
    window.open(item.url);
  }
}
